import { render, staticRenderFns } from "./VariantsConfig.vue?vue&type=template&id=2d94f052"
import script from "./VariantsConfig.vue?vue&type=script&lang=js"
export * from "./VariantsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports